import { render, staticRenderFns } from "./prizeSet.vue?vue&type=template&id=4014db02&scoped=true&"
import script from "./prizeSet.vue?vue&type=script&lang=js&"
export * from "./prizeSet.vue?vue&type=script&lang=js&"
import style0 from "./prizeSet.vue?vue&type=style&index=0&id=4014db02&prod&lang=less&scoped=true&"
import style1 from "./prizeSet.vue?vue&type=style&index=1&id=4014db02&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4014db02",
  null
  
)

export default component.exports